import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import styles from './stories.module.scss'

export default class SimpleSlider extends React.Component {
  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dotsClass: styles.stories__dots,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 150,
          },
        },
      ],
    }

    const data = this.props.data

    return (
      <Slider {...settings} className={styles.stories}>
        {data.map(s => (
          <div key={s.id} className={styles.stories__item}>
            <div
              className={styles.stories__content}
              dangerouslySetInnerHTML={{
                __html: s.story,
              }}
            />
            <p className={styles.stories__author}>
              <strong className="h4">{s.gymName}</strong>
              {s.personNameJobTitle}
            </p>
          </div>
        ))}
      </Slider>
    )
  }
}
